<template>
  <div class="super_container">
    <link rel="stylesheet" type="text/css" href="styles/contact_styles.css" />
    <link rel="stylesheet" type="text/css" href="styles/contact_responsive.css" />
    <!-- Home -->

    <div class="home">
      <!-- Image by https://unsplash.com/@peecho -->
      <div
        class="home_background parallax-window"
        data-parallax="scroll"
        style="background-image: url(images/news.jpg)"
        data-speed="0.8"
      ></div>
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="home_content">
              <div class="home_content_inner">
                <div class="home_title">Kontakt</div>
                <div class="home_breadcrumbs">
                  <ul class="home_breadcrumbs_list">
                    <li class="home_breadcrumb"><a href="index.html">Marena</a></li>
                    <li class="home_breadcrumb">Kontakt</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Find Form -->

    <TripContact />

    <!-- Contact -->

    <div class="contact">
      <div class="container">
        <div class="row">
          <div class="col">
            <div class="contact_title">Skontaktuj się</div>
            <div class="contact_subtitle">marena</div>
          </div>
        </div>
        <div class="row contact_content">
          <div class="col-lg-5">
            <div class="contact_text">
              <p>
                Kierując się dewizą, że każdą pracę należy wykonywać z ogromną starannością i
                zapałem nasi pracownicy od kilkunastu lat starają się sprostać oczekiwaniom naszych
                klientów. Oferują pełen zakres usług turystycznych i produktów z nimi związanych.
              </p>
            </div>
            <div class="contact_info">
              <div class="contact_info_box">i</div>
              <div class="contact_info_container">
                <div class="contact_info_content">
                  <ul>
                    <li>38-300 Gorlice</li>
                    <li>ul. Krakowska 2</li>
                    <li>NIP: 7381009911</li>
                    <li>tel: 601 083 770 / 18 354 07 21</li>
                    <li>e-mail: marena.gorlice@gmail.com</li>
                  </ul>
                </div>
                <div class="contact_info_social">
                  <ul>
                    <li>
                      <a href="https://web.facebook.com/biuropodrozy.marena/"
                        ><i class="fa fa-facebook" aria-hidden="true"></i
                      ></a>
                    </li>
                    <li>
                      <a href="https://www.instagram.com/marena.gorlice/"
                        ><i class="fa fa-instagram" aria-hidden="true"></i
                      ></a>
                    </li>
                    <li>
                      <a href="https://www.youtube.com/channel/UCOzP6-lTg6Zs4tHJqibFzDw"
                        ><i class="fa fa-youtube" aria-hidden="true"></i
                      ></a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-7">
            <div class="contact_form_container">
              <form id="contact_form" class="clearfix" @submit.prevent>
                <input
                  id="contact_input_name"
                  v-model="name"
                  class="contact_input contact_input_name"
                  type="text"
                  placeholder="Imię"
                  required="required"
                  data-error="Proszę podać imię."
                />
                <input
                  id="contact_input_email"
                  v-model="email"
                  class="contact_input contact_input_email"
                  type="text"
                  placeholder="E-mail"
                  required="required"
                  data-error="Proszę podać email."
                />
                <input
                  id="contact_input_subject"
                  v-model="topic"
                  class="contact_input contact_input_subject"
                  type="text"
                  placeholder="Temat"
                />
                <textarea
                  id="contact_input_message"
                  v-model="text"
                  class="contact_message_input contact_input_message"
                  name="message"
                  placeholder="Wiadomość"
                  required="required"
                  data-error="Proszę wprowadzić wiadomość."
                ></textarea>
                <router-link v-if="loggedUser" :to="{ name: 'contacts' }"
                  >Zarządzaj wiadomościami</router-link
                >
                <m-button
                  id="contact_send_btn"
                  class="contact_send_btn trans_200"
                  value="Submit"
                  :blocked="sendingData"
                  @click="send"
                >
                  Wyślij
                </m-button>
              </form>
            </div>
          </div>
        </div>
        <div class="row contact_map">
          <!-- Google Map -->

          <div class="col">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2582.7859608909416!2d21.15284321577176!3d49.658332079373864!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x473dc6928d798a8f%3A0x8b2fd181006f0dde!2zTWFyZW5hIEJpdXJvIFBvZHLDs8W8eSBLb8WbxIcgUmVuYXRh!5e0!3m2!1sen!2spl!4v1564802290580!5m2!1sen!2spl"
              width="100%"
              height="450"
              frameborder="0"
              style="border: 0"
              allowfullscreen
            ></iframe>
          </div>
        </div>
      </div>
    </div>

    <script2 src="plugins/scrollmagic/ScrollMagic.min.js"></script2>
    <script2
      src="https://maps.googleapis.com/maps/api/js?v=3.exp&key=AIzaSyCIwF204lFZg1y4kPSIhKaHEXMLYxxuMhA"
    ></script2>
    <script2 src="js/contact_custom.js"></script2>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import cli from '@/http.js'
import TripContact from '@/components/TripContact.vue'

export default {
  name: 'Contact',
  components: {
    TripContact,
  },
  data() {
    return {
      name: '',
      email: '',
      topic: '',
      text: '',
      sendingData: false,
    }
  },
  computed: {
    ...mapState(['loggedUser']),
  },
  methods: {
    async send() {
      const data = {
        name: this.name,
        email: this.email,
        topic: this.topic,
        text: this.text,
      }
      this.sendingData = true
      try {
        await cli.post('/contacts/', data)
        this.$notify({
          title: 'Wiadomość wysłana pomyślnie.',
          type: 'success',
        })
        this.name = ''
        this.email = ''
        this.topic = ''
        this.text = ''
      } catch {
        this.$notify({
          title: 'Błąd',
          text: 'Spróbuj jeszcze raz.',
          type: 'error',
        })
      } finally {
        this.sendingData = false
      }
    },
  },
}
</script>

<style scoped>
.contact_send_btn {
  background: rgb(239, 126, 26);
}
.contact_send_btn:hover {
  background: #e0710f;
}
.contact_info_box {
  background: rgb(239, 126, 26);
}
</style>
